module.exports = __webpack_public_path__ + "img/60600.b04e09fb.jpg";